// extracted by mini-css-extract-plugin
export default {"content":"index_content_rsXeq","content_left":"index_content_left_prxgX","content_right":"index_content_right_a1nMt"};